/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * none means that the tickets are refunded and nothing else sale does same as none but ticket are put back to sale cart does as sale but also keeps the tickets in the user cart
 */
export type RefundTicketActionEnum = 'none' | 'sale' | 'cart';

export const RefundTicketActionEnum = {
    None: 'none' as RefundTicketActionEnum,
    Sale: 'sale' as RefundTicketActionEnum,
    Cart: 'cart' as RefundTicketActionEnum
};

